import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue";
var _hoisted_1 = {
  class: "mobile-form-item"
};
var _hoisted_2 = {
  class: "label"
};
var _hoisted_3 = {
  key: 0,
  class: "label-desc"
};
var _hoisted_4 = {
  class: "value"
};
var _hoisted_5 = {
  class: "inline"
};
var _hoisted_6 = {
  key: 0,
  class: "error-tip"
};
var _hoisted_7 = {
  class: "inline"
};
var _hoisted_8 = {
  class: "t"
};
var _hoisted_9 = {
  key: 0,
  class: "error-tip"
};
var _hoisted_10 = {
  key: 0,
  class: "error-tip"
};
var _hoisted_11 = {
  key: 0,
  class: "error-tip"
};
var _hoisted_12 = {
  key: 0,
  class: "error-tip"
};
import { Field, ActionSheet, showToast } from "vant";
import { ref } from "vue";
import SvgIcon from "@/components/base/SvgIcon.vue";
import { computed } from "vue";
import { onMounted } from "vue";
import { getAllCountry } from "@/api/address";
import { sendCode } from "@/api/user.js";
import BaseCountDown from "@/components/base/baseCountDown.vue";
import { Persistent } from "@/utils/cache/persistent";
import { isPhoneAccount } from "../helper";
import { useSupplierStore } from "@/store/supplierStore";
import { getSupplyId } from "@/utils/authUtil";
import { TOO_MANY_REQUEST } from "@/constant/responseCode";
import DatePicker from "@/components/base/baseDatePicker.vue";
import { useDateFormat } from "@vueuse/core";
var key = "reg_count_down_key";
export default {
  __name: 'FormItem',
  props: {
    label: {
      type: String,
      default: ""
    },
    operation: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    },
    callcode: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    birthday: {
      type: Number,
      default: 0
    },
    birthdayFormatter: {
      type: String,
      default: "YYYY-MM-DD"
    },
    labelDesc: {
      type: String,
      default: ""
    }
  },
  emits: ["update:callcode", "phone:error", "update:birthday"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var supplierStore = useSupplierStore();
    var emit = __emit;
    var countdown = ref(0);
    var props = __props;
    var countries = ref([]);
    var isShowCallingCode = ref(false);
    var isShowBirthday = ref(false);
    var callCode = computed({
      get: function get() {
        return props.callcode;
      },
      set: function set(val) {
        emit("update:callcode", val);
      }
    });
    var isShowPassord = ref(false);
    var toggleShowPassword = function toggleShowPassword() {
      isShowPassord.value = !isShowPassord.value;
    };
    var fetchAllCountry = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, country, target;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(props.type === "phone")) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return getAllCountry();
            case 3:
              data = _context.sent;
              countries.value = data.filter(function (item) {
                return item.country_code !== "CN";
              }).map(function (item) {
                return {
                  name: "".concat(item.country_english_name, "(").concat(item.calling_code, ")"),
                  value: item.calling_code,
                  country_code: item.country_code
                };
              });
              country = supplierStore.getCountry;
              if (country) {
                target = countries.value.find(function (c) {
                  return c.country_code === country;
                });
                if (target) {
                  callCode.value = target.value;
                } else {
                  callCode.value = countries.value[0].value;
                }
              } else {
                callCode.value = countries.value[0].value;
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchAllCountry() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onSelect = function onSelect(e) {
      callCode.value = e.value;
      isShowCallingCode.value = false;
    };
    var sendStatus = ref("not_send");
    var time = Persistent.getLocal(key);
    if (time && new Date(time) instanceof Date) {
      var diff = (Date.now() - time) / 1000;
      if (diff < 60) {
        countdown.value = 60 - diff;
        sendStatus.value = "sent";
      }
    }
    var send = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(sendStatus.value !== "not_send")) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              if (!(!props.phone || !isPhoneAccount(props.phone))) {
                _context2.next = 5;
                break;
              }
              emit("phone:error");
              return _context2.abrupt("return");
            case 5:
              sendStatus.value = "sending";
              _context2.next = 8;
              return sendCode({
                area_code: props.callcode,
                operation: props.operation,
                phone: props.phone,
                country: supplierStore.getCountry,
                supplier_id: getSupplyId()
              });
            case 8:
              res = _context2.sent;
              if (res.isOK) {
                sendStatus.value = "sent";
                showToast(t("sent"));
                countdown.value = 60;
                Persistent.setLocal(key, Date.now());
              } else if (res.code === TOO_MANY_REQUEST) {
                showToast(t("frequentRequests"));
              } else {
                sendStatus.value = "not_send";
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function send() {
        return _ref3.apply(this, arguments);
      };
    }();
    var passwordFormatter = function passwordFormatter(val) {
      var newVal = val;
      if (/\s/.test(newVal)) {
        newVal = val.replace(/\s/g, "");
      } else {
        newVal = val;
      }
      return newVal;
    };
    var onCountdownEnd = function onCountdownEnd() {
      sendStatus.value = "not_send";
      countdown.value = 0;
    };
    onMounted(function () {
      fetchAllCountry();
    });
    function handleShowBirthday() {
      isShowBirthday.value = true;
    }
    var birthdayReal = computed({
      get: function get() {
        return props.birthday;
      },
      set: function set(val) {
        emit("update:birthday", val);
      }
    });
    return function (_ctx, _cache) {
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), __props.labelDesc ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.labelDesc), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_4, [__props.type === 'phone' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(Field), {
        "model-value": '+' + callCode.value,
        class: _normalizeClass(["field phone-prefix", {
          error: !!__props.error
        }]),
        readonly: "",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return isShowCallingCode.value = true;
        })
      }, {
        "right-icon": _withCtx(function () {
          return [_createVNode(SvgIcon, {
            class: "arrow-icon",
            name: "drop_down",
            onClick: toggleShowPassword
          })];
        }),
        _: 1
      }, 8, ["model-value", "class"]), _createVNode(_unref(Field), _mergeProps({
        class: ["field phone-field", {
          error: !!__props.error
        }],
        clearable: ""
      }, _ctx.$attrs, {
        type: "number",
        placeholder: _ctx.$t('pleaseEnterThePhoneNumber7To20'),
        maxlength: "20"
      }), null, 16, ["class", "placeholder"])]), __props.error ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.error), 1)) : _createCommentVNode("", true)], 64)) : __props.type === 'reg' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(Field), _mergeProps({
        class: ["field", {
          error: !!__props.error
        }]
      }, _ctx.$attrs, {
        placeholder: _ctx.$t('pleaseEnterVerificationCode')
      }), null, 16, ["class", "placeholder"]), _createVNode(BaseCountDown, {
        time: countdown.value,
        onEnd: onCountdownEnd
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_8, [_createVNode(_component_Button, {
            class: _normalizeClass(["send-btn", {
              sending: sendStatus.value === 'sending'
            }]),
            disabled: sendStatus.value !== 'not_send',
            type: "border",
            onClick: send
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(sendStatus.value === "sending" ? _ctx.$t("loading") : sendStatus.value === "sent" ? scope.ss + "s" : _ctx.$t("send")), 1)];
            }),
            _: 2
          }, 1032, ["disabled", "class"])])];
        }),
        _: 1
      }, 8, ["time"])]), __props.error ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.error), 1)) : _createCommentVNode("", true)], 64)) : __props.type === 'password' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createVNode(_unref(Field), _mergeProps({
        class: ["field", {
          error: !!__props.error
        }],
        clearable: ""
      }, _ctx.$attrs, {
        maxlength: "20",
        autocomplete: "",
        type: isShowPassord.value ? 'text' : 'password',
        placeholder: _ctx.$t('pleaseEnterThePassword6To20'),
        formatter: passwordFormatter
      }), {
        "right-icon": _withCtx(function () {
          return [_createVNode(SvgIcon, {
            class: "icon",
            name: isShowPassord.value ? 'eye_open' : 'eye_close',
            onClick: toggleShowPassword
          }, null, 8, ["name"])];
        }),
        _: 1
      }, 16, ["class", "type", "placeholder"]), __props.error ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.error), 1)) : _createCommentVNode("", true)], 64)) : __props.type === 'birthday' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createVNode(_unref(Field), _mergeProps({
        "model-value": __props.birthday > 0 ? _unref(useDateFormat)(__props.birthday, __props.birthdayFormatter).value : '',
        class: "field",
        readonly: "",
        placeholder: _ctx.$t('pleaseSelect')
      }, _ctx.$attrs, {
        onClick: handleShowBirthday
      }), null, 16, ["model-value", "placeholder"]), __props.error ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(__props.error), 1)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createVNode(_unref(Field), _mergeProps({
        class: ["field", {
          error: !!__props.error
        }]
      }, _ctx.$attrs), null, 16, ["class"]), __props.error ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(__props.error), 1)) : _createCommentVNode("", true)], 64))]), _createVNode(_unref(ActionSheet), {
        show: isShowCallingCode.value,
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return isShowCallingCode.value = $event;
        }),
        actions: countries.value,
        onSelect: onSelect
      }, null, 8, ["show", "actions"]), _createVNode(DatePicker, {
        visible: isShowBirthday.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return isShowBirthday.value = $event;
        }),
        value: birthdayReal.value,
        "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
          return birthdayReal.value = $event;
        })
      }, null, 8, ["visible", "value"])]);
    };
  }
};